import ApplyCancelModal from './ApplyCancelModal';
import ResumeDeleteModal from './ResumeDeleteModal';
import ResumeEndModal from './ResumeEndModal';
import ResumeSaveModal from './ResumeSaveModal';
import PositionEndModal from './PositionEndModal';

interface ApplyModalsProps {
  positionSn: number;
  modalState: ModalTypes | null;
  onClose: () => void;
  openModal: (modalState: ModalTypes) => void;
  confirmAfter: () => void;
}

export type ModalTypes = 'RESUME_DELETE' | 'RESUME_SAVE' | 'APPLY_CANCEL' | 'RESUME_END' | 'POSITION_END';

const ApplyModals = ({ positionSn, modalState, onClose, openModal, confirmAfter }: ApplyModalsProps) => {
  const isVisibleModal = (modalType: string) => modalType === modalState;

  const handleCloseResumeSaveModal = () => {
    openModal('APPLY_CANCEL');
  };

  return (
    <>
      <ApplyCancelModal
        visible={isVisibleModal('APPLY_CANCEL')}
        onClose={onClose}
        positionSn={positionSn}
        confirmAfter={confirmAfter}
      />
      <ResumeDeleteModal
        visible={isVisibleModal('RESUME_DELETE')}
        onClose={onClose}
        positionSn={positionSn}
        confirmAfter={confirmAfter}
      />
      <ResumeSaveModal
        visible={isVisibleModal('RESUME_SAVE')}
        onClose={handleCloseResumeSaveModal}
        positionSn={positionSn}
      />
      <ResumeEndModal
        visible={isVisibleModal('RESUME_END')}
        onClose={onClose}
        positionSn={positionSn}
        confirmAfter={confirmAfter}
      />
      <PositionEndModal visible={isVisibleModal('POSITION_END')} onClose={onClose} />
    </>
  );
};

export default ApplyModals;
